import { withIndexEndpoint, withOptionsEndpoint, withStoreEndpoint } from "@dgs/core";
import { OrganizerIndexResource, OrganizerOptionResource, OrganizerSaveRequest } from "../types/organizer";

const baseKey = ["organizers"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const organizerService = {
	...withIndexEndpoint<OrganizerIndexResource>(baseKey),
	...withOptionsEndpoint<OrganizerOptionResource>(baseKey),
	...withStoreEndpoint<OrganizerSaveRequest>(baseKey),
	quickFilterKey,
};
